<template>
  <d-modal @close="handleClose">
    <d-modal-header>
      <d-modal-title>
        {{ $t('customer.addContactPerson') }}
      </d-modal-title>
    </d-modal-header>
    <d-modal-body>
      <d-form>
        <validation-observer ref="customer-contact-person-add-form" tag="form" @keydown.enter.prevent>
          <div class="form-group">
            <label>
              {{ $t('ui.nameAndSurename') }}:
            </label>

            <validation-provider
              rules="required"
              name="name"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                v-model="name" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('ui.emailAddress') }}:
            </label>

            <validation-provider
              rules="required|email"
              name="email"
              v-slot="{ errors }">
              <d-input
                :state="errors.length ? 'invalid' : null"
                type="email"
                v-model="email" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>

          <div class="form-group">
            <label for="name">
              {{ $t('customer.telephone') }}:
            </label>

            <validation-provider
              rules="required"
              name="phone"
              v-slot="{ errors }">
              <d-input
                v-mask="'+## ### ### ### ### ### ### ### ### ###'"
                :state="errors.length ? 'invalid' : null"
                v-model="phone" />
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </validation-observer>
      </d-form>
    </d-modal-body>
    <d-modal-footer>
      <d-button
        class="ml-0"
        theme="danger"
        @click.prevent="cancel">
        {{ $t('ui.cancel') }}
      </d-button>
      <d-button
        class="ml-auto"
        theme="success"
        @click.prevent="validateForm">
        {{ $t('customer.addContactPerson') }}
      </d-button>
    </d-modal-footer>
  </d-modal>
</template>

<script>
import FormUtils from './../../utils/FormUtils.js';

export default {
  name: 'customer-contact-person-new-popup',
  props: {
    customerID: {
      default: 0,
      type: Number
    },
    mode: {
      default: 'partner',
      type: String
    }
  },
  data () {
    return {
      name: '',
      email: '',
      phone: ''
    };
  },
  methods: {
    handleClose (newContactID = false) {
      this.$bus.$emit('customer-add-contact-person-popup-close', newContactID);
    },
    validateForm () {
      FormUtils.validate(this.$refs['customer-contact-person-add-form'], this.saveContactPerson);
    },
    saveContactPerson () {
      let endpoint = '/customer-panel/customers/contacts/store';

      if (this.mode === 'partner-customer') {
        endpoint = '/customer-panel/partner-customers/contacts/store';
      }

      FormUtils.submit({
        $http: this.$http,
        endpoint,
        formData: {
          customer_id: this.customerID === 0 ? this.$store.getters.getCustomerID : this.customerID,
          name: this.name,
          email: this.email,
          phone: this.phone
        },
        successTitle: this.$t('customer.addContactPersonSuccessTitle'),
        successText: this.$t('customer.addContactPersonSuccessText'),
        errorTitle: this.$t('ui.errorOccured'),
        errorText: this.$t('customer.addContactPersonErrorText'),
        successAction: res => {
          this.$bus.$emit('customer-reload-contact-persons');
          this.handleClose(res.id);
        }
      });
    },
    cancel () {
      this.handleClose();
    }
  }
}
</script>
